import { z } from 'zod';
import type { TaiKhoanCuaHang } from '@/types/schemas';

export const formSchema = z.object({
  uuid: z.string().optional(),
  ma_cuahang: z.string().nonempty('Mã cửa hàng là bắt buộc'),
  ma_kho: z.string().optional(),
  ma_bp: z.string().optional(),
  tk_cn: z.string().optional(),
  tk_cn2: z.string().optional(),
  tk_tm: z.string().optional(),
  status: z.number().default(1),
  ma_kho_data: z.custom<NonNullable<TaiKhoanCuaHang['ma_kho_data']>>().optional(),
  ma_bp_data: z.custom<NonNullable<TaiKhoanCuaHang['ma_bp_data']>>().optional(),
  tk_cn_data: z.custom<NonNullable<TaiKhoanCuaHang['tk_cn_data']>>().optional(),
  tk_cn2_data: z.custom<NonNullable<TaiKhoanCuaHang['tk_cn2_data']>>().optional(),
  tk_tm_data: z.custom<NonNullable<TaiKhoanCuaHang['tk_tm_data']>>().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_cuahang: '',
  status: 1
};
